module.exports = __webpack_public_path__ + "img/s-sl-img-4.6d0357f7.png";